var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { axiosInstance } from '@/api/realApi/_axios';
import { joinUrl } from '@/api/realApi/_utils';
import { getCsrfHeaders } from '@/api/realApi/authApi';
const USER_URL_PATH = '/api/users/';
export const userApi = {
    getUser: () => __awaiter(void 0, void 0, void 0, function* () {
        const res = yield axiosInstance.get(joinUrl([USER_URL_PATH, '/user/']));
        return res.data;
    }),
    getUserSettings: (roomCode) => __awaiter(void 0, void 0, void 0, function* () {
        const res = yield axiosInstance.get(joinUrl([USER_URL_PATH, '/user/settings/get_user_settings/']), {
            params: { room_code: roomCode },
        });
        return res.data.settings;
    }),
    updateUserSettings: (data) => __awaiter(void 0, void 0, void 0, function* () {
        const config = yield getCsrfHeaders();
        const res = yield axiosInstance.put(joinUrl([USER_URL_PATH, '/user/settings/update_settings/']), data, config);
        return res.data.settings;
    }),
};
